function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotfound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 504 504",
    style: {
      enableBackground: "new 0 0 504 504"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#d9d9d9"
    },
    cx: 252,
    cy: 252,
    r: 252
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff7058"
    },
    d: "M94.5 104.3h315v295.3h-315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M122.1 170.6H382v201.5H122.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f1543f"
    },
    d: "M122.1 127.9h32.5v19.2h-32.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffd05b"
    },
    d: "M175.7 127.9h32.5v19.2h-32.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e6e9ee"
    },
    d: "M229.4 127.9h32.5v19.2h-32.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324a5e"
    },
    d: "m174.9 279 28.4-42.1H216v41.7h8.3l-1.6 9.5-6.6.3v16.8H203v-16.5h-7c-1.5 0-3 0-4.6-.1h-4.8c-3.7 0-7.6-.1-11.7-.1V279zm8.1-.3h20v-30.9l-20 30.9zM251.9 306.2c-4.1 0-7.6-.8-10.5-2.3s-5.3-3.7-7.1-6.6-3.2-6.6-4-10.9-1.3-9.3-1.3-15c0-5.4.4-10.2 1.2-14.5s2.1-8 3.9-11 4.1-5.3 7.1-6.9c2.9-1.6 6.5-2.4 10.6-2.4s7.7.8 10.6 2.3c2.9 1.6 5.3 3.8 7.1 6.8 1.8 3 3.1 6.6 4 10.9.8 4.3 1.2 9.2 1.2 14.7 0 5.4-.4 10.3-1.2 14.6-.8 4.3-2.1 8-4 11-1.8 3-4.2 5.3-7.1 6.9-2.9 1.5-6.4 2.4-10.5 2.4zm-9.4-34.9c0 9.7.7 16.8 2 21.3 1.4 4.5 3.8 6.8 7.3 6.8 1.3 0 2.5-.2 3.7-.5s2.2-.8 3.2-1.3c.8-.5 1.4-2.9 1.9-7.2.5-4.2.7-10.6.7-19.1 0-9.6-.7-16.6-2.1-21.3-1.4-4.6-3.8-6.9-7.2-6.9-1.3 0-2.4.1-3.4.4-1 .2-1.9.6-2.8 1-1 .5-1.8 3.1-2.4 7.6-.6 4.6-.9 11-.9 19.2zM279.8 279l28.4-42.1h12.6v41.7h8.3l-1.6 9.5-6.6.3v16.8H308v-16.5h-7c-1.5 0-3 0-4.6-.1h-4.8c-3.7 0-7.6-.1-11.7-.1V279h-.1zm8.1-.3h20v-30.9l-20 30.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#54c0eb"
    },
    d: "M147.7 198.9h164.6v11.8H147.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f1543f"
    },
    d: "M334.3 198.9h22v11.8h-22z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffd05b"
    },
    d: "M147.7 332h164.6v11.8H147.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324a5e"
    },
    d: "M334.3 332h22v11.8h-22z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotfound);
export default __webpack_public_path__ + "static/media/notfound.a50cd074e167ee7bbcca2b165fcc7189.svg";
export { ForwardRef as ReactComponent };